export default __webpack_public_path__ + "static/media/time_vertical.33d2ead2.jpg";